"use client";

import { c as _c } from "react/compiler-runtime";
import { usePostHog } from "posthog-js/react";
import { useEffect } from "react";

/**
 * Reports a search the service-area gate refused. Call it from the component
 * that renders the blocked state, which mounts only while blocked; keyed on
 * the city so a re-render does not re-send.
 *
 * `source` separates the two places the gate can fire: `search` is a
 * destination picked in a search entry point, `results` is a pasted or
 * deep-linked destination that never reaches the API. Mirrors the
 * `search_blocked_out_of_area` capture in `ezspot-mobile`, same property names,
 * so one funnel covers both clients.
 */
export function useSearchBlockedOutOfArea(city, source) {
  const $ = _c(5);
  const posthog = usePostHog();
  let t0;
  let t1;
  if ($[0] !== city || $[1] !== posthog || $[2] !== source) {
    t0 = () => {
      posthog?.capture("search_blocked_out_of_area", {
        city: city ?? null,
        source
      });
    };
    t1 = [posthog, city, source];
    $[0] = city;
    $[1] = posthog;
    $[2] = source;
    $[3] = t0;
    $[4] = t1;
  } else {
    t0 = $[3];
    t1 = $[4];
  }
  useEffect(t0, t1);
}